import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbAccordionModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap'
import { SharedModule } from '@tv3/shared/shared.module'
import { ChannelSharedModule } from '@tv3/containers/channels/shared/channel-shared.module'
import { AccountOnboardingCard } from './account-onboarding-card'
import { DownloadApp } from './download-app/download-app'
import { DownloadAppService } from './download-app/download-app.service'
import { SubscribeRategenie } from './subscribe-rategenie/subscribe-rategenie'
import { QRCodeModule } from 'angularx-qrcode'
import { AccountOnboardingCardPopup } from './account-onborading-popup'
import { SubscribeRategenieService } from './subscribe-rategenie/subscribe-rategenie.service'

const components = [AccountOnboardingCard, DownloadApp, SubscribeRategenie, AccountOnboardingCardPopup]

const modules = [SharedModule, ChannelSharedModule, NgbAccordionModule, NgbProgressbarModule, QRCodeModule]

@NgModule({
  imports: [CommonModule, ...modules],
  declarations: [...components],
  exports: [...components, ...modules],
  providers: [DownloadAppService, SubscribeRategenieService],
})
export class AccountOnboardingModule {}
